import { render } from "./legoTree.vue?vue&type=template&id=27376790"
import script from "./legoTree.vue?vue&type=script&lang=js"
export * from "./legoTree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoTree/legoTree.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27376790"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27376790', __exports__)) {
    api.reload('27376790', __exports__)
  }
  
  module.hot.accept("./legoTree.vue?vue&type=template&id=27376790", () => {
    api.rerender('27376790', render)
  })

}


export default __exports__